import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../services/order.service';
import {
    CartFace,
    CartInfos,
    CartScreenPark,
    CompatibleTypeEnum,
} from '../model/store.model';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../../services/alert/alert.service';
import { environment } from '../../../../environments/environment';
import { WaitingService } from '../../layout/waiting/waiting.service';

@Component({
    selector: 'app-pay-confirm',
    templateUrl: './pay-confirm.component.html',
    styleUrl: './pay-confirm.component.scss',
})
export class PayConfirmComponent implements OnInit {
    //#region Variables
    public orderId: number = null;
    public orderRecap: CartInfos = null;
    public isOrderRecapLoading: boolean = false;
    public baseUrl: string;
    //#endregion Variables

    public displayDialog: boolean = true;
    // MARK: CONSTRUCTOR
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private order$: OrderService,
        private alert$: AlertService,
        private waiting$: WaitingService
    ) {
        this.baseUrl = environment.apiBaseStore;
    }

    ngOnInit(): void {
        const orderIdStr: string = this.route.snapshot.paramMap.get('orderId');

        if (
            orderIdStr == null ||
            orderIdStr === '' ||
            orderIdStr === 'null' ||
            orderIdStr === 'undefined'
        ) {
            //Error
        } else {
            this.orderId = parseInt(orderIdStr);

            this.loadOrderRecap();
        }
    }

    /**
     * Charge les infos de la commande
     */
    public loadOrderRecap() {
        this.isOrderRecapLoading = true;

        const waitingId: string = this.waiting$.start();
        this.order$.getRecapOrder(this.orderId).subscribe({
            next: (cartInfos: CartInfos) => {
                this.waiting$.end(waitingId);
                this.orderRecap = cartInfos;

                this.orderRecap.sp.forEach((screenPark: CartScreenPark) => {
                    screenPark.expend = false;
                    let i: number = 0;
                    screenPark.fAs.forEach((face: CartFace) => {
                        if (i > 4) {
                            face.hide = true;
                        }
                        i++;
                    });
                });
                this.isOrderRecapLoading = false;
            },
            error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);
                console.error(err);

                this.alert$.show({
                    message:
                        'Erreur lors de la récupération des infos de votre commande',
                    duration: 1700,
                });
                this.isOrderRecapLoading = false;
            },
        });
    }

    /**
     *
     * @param ic IsCompatible Type
     * @returns Le texte correspondant pour l'afficher dans le paniers
     */
    getOccupedType(ic: CompatibleTypeEnum) {
        switch (ic) {
            case CompatibleTypeEnum.NotInstall:
                return 'Ecran pas encore installé';
            case CompatibleTypeEnum.UnInstall:
                return 'Ecran désinstallé';

            case CompatibleTypeEnum.Full:
            default:
                return 'Ecran plein';
        }
    }

    expendSP(sp: any) {
        sp.expend = true;
        sp.fAs.forEach((face) => {
            face.hide = false;
        });
    }

    minusSP(sp: any) {
        sp.expend = false;
        let i = 0;
        sp.fAs.forEach((face) => {
            if (i > 4) {
                face.hide = true;
            }
            i++;
        });
    }

    /**
     * Redirection vers la page 'park'
     */
    goToPark() {
        //Vider le localStorage
        this.clearCampaignLocalStorage();

        this.router.navigateByUrl('/park');
    }

    /**
     * Vide le localStorage de la campagne actuelle
     */
    private clearCampaignLocalStorage() {
        localStorage.removeItem('campaignEndDate');
        localStorage.removeItem('campaignStartDate');
        localStorage.removeItem('campaignName');
        localStorage.removeItem('selectedFace');
    }
}
